import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DocumentVersion } from "./types";
import { Info } from "lucide-react";

interface VersionSelectorProps {
  versions: DocumentVersion[];
  currentVersion: string;
  onVersionChange: (version: string) => void;
}

export const VersionSelector: React.FC<VersionSelectorProps> = ({
  versions,
  currentVersion,
  onVersionChange
}) => {
  const selectedVersion = versions.find(v => v.version === currentVersion);

  return (
    <div className="border-t border-gray-200 bg-gray-50 p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-start gap-2">
          <Info className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm font-semibold text-gray-900">Versão do Documento</p>
            <p className="text-xs text-gray-600 mt-1">
              {selectedVersion?.changelog || 'Selecione uma versão para ver o histórico'}
            </p>
          </div>
        </div>
        
        <div className="w-full sm:w-64">
          <Select value={currentVersion} onValueChange={onVersionChange}>
            <SelectTrigger className="bg-white border-gray-300">
              <SelectValue placeholder="Selecione a versão" />
            </SelectTrigger>
            <SelectContent>
              {versions.map((version) => (
                <SelectItem key={version.version} value={version.version}>
                  {version.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};
